import React, { useState } from 'react'
import styles from './SaveAsNewTRouteModal.scss'
import { ConfirmationDialog } from 'common/styleguide/ConfirmationDialog'
import { FancyCheckmark } from 'common/FancyCheckmark'
import { srMessages } from 'features/recumbent/SaveRoute'
import { organizedMessages } from 'features/recumbent/SaveRoute/SaveSuccess'
import { errorMessage } from 'lib/styleguide/base.scss'
import fetchJSON from 'lib/fetchJSON'
import { Msg, useFormatMessage, commonVerbs, commonNouns, commonMessages } from 'lib/localization'
import { TrackLocation } from 'data/records'
import p from 'prop-types'
import { FormattedMessage as T, defineMessages } from 'react-intl'
import _ from 'lodash'

export const SAVE_AS_NEW_TROUTE_MODAL = 'SAVE_AS_NEW_TROUTE_MODAL'

const messages = defineMessages({
  asASeparateRide: {
    id: 'SaveAsNewTRouteModal.asASeparateRide',
    defaultMessage: 'Save as a separate ride'
  }
})

export const SaveAsNewTRouteModal = ({ highlightSlice, troute, objectType, saveAs, onRequestClose }) => {
  const [name, setName] = useState('')
  const [save, setSave] = useState({ result: null, error: null, pending: false })
  const fm = useFormatMessage()

  const onInputChange = (e) => setName(e.target.value)

  const onSubmit = (e) => {
    e && e.preventDefault()

    const indexes = highlightSlice.map(TrackLocation.closestIndex)
    const url = saveAs === 'route'
      ? '/routes/new_from_slice.json'
      : `/trips/${troute.id}/new_from_slice.json`

    const postData = {
      i: indexes[0],
      count: indexes[1] - indexes[0],
      assetType: objectType,
      assetId: troute.id,
      name
    }

    setSave({ ...save, savePending: true })
    fetchJSON(url, postData)
      .then(result => setSave({ result, saveError: null, savePending: false }))
      .catch(error => setSave({ error, saveResult: null, savePending: false }))
  }

  const viewTRoute = () => window.location.assign(`/${saveAs === 'route' ? 'routes' : 'trips'}/${save.result.id}`)

  const location = fm(organizedMessages.yourThings, { objectType: fm(saveAs === 'route' ? commonNouns.routes : commonNouns.trips, { count: 0 }) })
  const localizedString = _.capitalize(fm(saveAs === 'route'
    ? commonNouns.routes
    : commonNouns.trips, { count: 1 }))
  const confirmText = save.result
    ? fm(organizedMessages.view, { asset: localizedString })
    : fm(commonVerbs.save)

  return (
    <ConfirmationDialog
      title={fm(saveAs === 'route' ? srMessages.saveAsNew : messages.asASeparateRide)}
      maxWidth='600px'
      confirmText={confirmText}
      onCancel={onRequestClose}
      onRequestClose={onRequestClose}
      showCancel={!save.result}
      onConfirm={save.result ? viewTRoute : onSubmit}
      confirmPending={save.pending}>
      <div>
        {!save.result && <form onSubmit={onSubmit}>
          <p className={styles.lessMargin}>
            {saveAs === 'route'
              ? <T id='SaveAsNewTRouteModal.routeDesc' defaultMessage='A route is just a map of the ride without any time data associated with it. You can edit a route to help you plan future rides.' />
              : <T id='SaveAsNewTRouteModal.tripDesc' defaultMessage='Have you ever forgotten to turn off your GPS between rides and ended up with a mess? Now you can split your rides into multiple activities to clean them up!' />}
          </p>
          <label htmlFor='name'><Msg capitalized m={commonNouns.name} />:</label>
          <input type='text' id='name' onChange={onInputChange} value={name} name='name' />
        </form>}
        {save.error && <div className={errorMessage}>
          {fm(commonMessages.errorMessageGeneric)}
        </div>}
        {save.result && <div className={styles.successMessage}>
          <FancyCheckmark />
          <Msg m={organizedMessages.savedTo} values={{
            name: save.result.name,
            location,
            strong: (...c) => <strong>{c}</strong>
          }} />
        </div>}
      </div>
    </ConfirmationDialog>
  )
}

SaveAsNewTRouteModal.propTypes = {
  highlightSlice: p.array,
  onRequestClose: p.func
}
